import React from 'react'

import { Medtech2024TrendsInsights } from '@components/articles/Medtech2024TrendsInsights'
import { CustomHead } from '@ui/sections/CustomHead'

function Medtech2024TrendsInsightsPage() {
  return (
    <>
      <CustomHead
        title="Medtech 2024: Trends, Insights, and Innovations | Modsen’s Impactful Advisory Initiative"
        imagePath="/images/articles/medtech-2024-trends-insights/opengraph.webp"
        description="Gain strategic insights, recommendations, and a deep dive into the evolving medtech landscape, shaped by Modsen’s proactive industry involvement."
        pageType="article"
      />
      <Medtech2024TrendsInsights />
    </>
  )
}

export default Medtech2024TrendsInsightsPage
